module.exports = __webpack_public_path__ + "img/instagram.4121014e.svg";